import React, { useEffect, useRef, useState } from 'react';
import './styles.css';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';

const MarqueeComponent: React.FC = () => {
  const { RestorationStore } = useStore();
 
  const marqueeRef = useRef<HTMLDivElement>(null);
  const [marqueeContent, setMarqueeContent] = useState<string | null>(null);

const APICall =async()=>{
  await RestorationStore.OperatorRemainter();
  const initialContent=RestorationStore.FooterOperatorRemainter?.replace(/\+/g, '') || null;
  setMarqueeContent(initialContent);
}

  useEffect(() => {
    APICall();
    const interval = setInterval(APICall, 30000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);
  return (
    <div className="marquee-container">
      <div className="marquee marquee-animation" ref={marqueeRef}>
        <p>{marqueeContent}</p>
      </div>
    </div>
  );
};

export default observer(MarqueeComponent);


